import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { z } from 'zod';
import { donedealGateway } from '../../../../../../api/api-utils/commonApiUtils';

const WhatsAppLinkSchema = z.object({
  url: z.string(),
});

export type UseGetWhatsAppLinkResult = UseQueryResult<
  typeof useGetWhatsAppLink
>;

export const useGetWhatsAppLink = (
  adId: number,
  useQueryOptions?: {
    enabled: boolean;
  },
) => {
  return useQuery({
    queryKey: ['whatsAppLink', adId],
    queryFn: async (): Promise<string> => {
      const response = await donedealGateway.get(
        `/ddapi/v1/listings/${adId}/whatsapp/enquiry`,
      );

      const parsedResponse = WhatsAppLinkSchema.parse(response.data);

      return parsedResponse.url;
    },
    enabled: useQueryOptions?.enabled ?? true,
  });
};
